import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'app-item-event-content',
  templateUrl: './item-event-content.component.html',
  styleUrls: ['./item-event-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemEventContentComponent implements OnInit {
  @Input() fromChecklist: boolean = false;
  @Input() withCheck: boolean = false;
  @Input() iconClass: string = '';
  @Input() label: string = '';
  @Input() value: string = '';
  @Input() isTypeLink: boolean = false;
  @Input() href: string = '';
  public isCopy = false;
  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {}

  copyValue(event: Event | undefined): void {
    event?.stopPropagation();
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(this.value)
        .then(() => {
          this.enableCopy();
          setTimeout(() => {
            this.disableCopy();
          }, 500);
        })
        .catch((err) => {
          console.error('Error al copiar al portapapeles: ', err);
        });
    } else {
      console.warn('El portapapeles no está soportado en este navegador');
    }
  }

  private disableCopy(): void {
    this.isCopy = false;
    this.cdr.detectChanges();
  }

  private enableCopy(): void {
    this.isCopy = true;
    this.cdr.detectChanges();
  }
}
